import React, { useMemo } from 'react'
import './data.scss'
import Tab, { TabItem } from '@/components/tab/tab'
import { getBEMCls } from '@/utils/classname'
import { MainHeader, Column, Expaned } from '@/components/layout/layout'
import DataContent, { ACCOUNT_CHECKING, DATA_VIEW, GOODS_SALE_CHART, MEMBER_DATA } from './router'
import { RouteComponentProps } from 'react-router'

const PurchaseManage = (props: RouteComponentProps) => {
    const tabList: TabItem[] = useMemo(
        () => [
            {
                id: 0,
                name: '数据概览',
                route: DATA_VIEW,
            },
            {
                id: 1,
                name: '商品销售',
                route: GOODS_SALE_CHART,
            },
            {
                id: 2,
                name: '会员数据',
                route: MEMBER_DATA,
            },
            {
                id: 3,
                name: '资金对账',
                route: ACCOUNT_CHECKING,
            },
        ],
        [],
    )

    const getCls = (el?: string, m?: string) => getBEMCls('data-manage', el, m)

    return (
        <Column className={getCls()} data-height-100p>
            <MainHeader>
                <Tab tabList={tabList} />
            </MainHeader>
            <Expaned className={getCls('content')} data-overflow-hidden>
                <DataContent {...props} />
            </Expaned>
        </Column>
    )
}

export default PurchaseManage
